/* ShinePod / Swissker FAQ page — sidebar scroll-spy + single-open accordion (per group optional). */
(function () {
  if (window.__spFaqInit) return;
  window.__spFaqInit = true;
  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-sp-faq]');
    if (!root) return;

    var links = Array.prototype.slice.call(root.querySelectorAll('[data-faq-nav]'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-faq-group]'));

    // smooth scroll + set active on click
    links.forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href');
        if (id && id.charAt(0) === '#') {
          var target = document.querySelector(id);
          if (target) {
            e.preventDefault();
            var top = target.getBoundingClientRect().top + window.pageYOffset - (root.getAttribute('data-offset') ? parseInt(root.getAttribute('data-offset'), 10) : 100);
            window.scrollTo({ top: top, behavior: 'smooth' });
            history.replaceState(null, '', id);
          }
        }
      });
    });

    // scroll-spy
    function setActive(id) {
      links.forEach(function (a) {
        var on = a.getAttribute('href') === '#' + id;
        a.classList.toggle('is-active', on);
      });
    }
    if ('IntersectionObserver' in window && groups.length) {
      var visible = {};
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { visible[en.target.id] = en.isIntersecting ? en.intersectionRatio : 0; });
        var best = null, bestR = 0;
        Object.keys(visible).forEach(function (k) { if (visible[k] > bestR) { bestR = visible[k]; best = k; } });
        if (best) setActive(best);
      }, { rootMargin: '-20% 0px -65% 0px', threshold: [0, 0.25, 0.5, 1] });
      groups.forEach(function (g) { obs.observe(g); });
    }
    if (groups[0]) setActive(groups[0].id);

    // accordion: optionally close siblings within the same group
    var single = root.getAttribute('data-single') === 'true';
    if (single) {
      root.querySelectorAll('[data-faq-group] details').forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          var group = d.closest('[data-faq-group]');
          if (!group) return;
          group.querySelectorAll('details[open]').forEach(function (o) { if (o !== d) o.open = false; });
        });
      });
    }
  });
})();
